angular.module('routes.import.ImportPayloadResolver', [
  'stack'
])

/**
 * The ImportPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class ImportPayloadResolver
 * @constructor
 * @module routes.import.ImportPayloadResolver
 */
.factory('ImportPayloadResolver', [
  'GLOBAL',
  'ModelsService',
  function (GLOBAL, ModelsService) {
    'use strict';

    return function () {
      return ModelsService.initialize('cases', GLOBAL.apiPath + '/cases');
    };
  }
]);
